/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Injectable } from '@angular/core';
import { CommonUtils } from '../tool/common-utils';
import { NameValue } from '../tool/name-value';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  public document = document;
  public DEFAULT_DURATION_SECONDS = 60 * 60 * 24;

  public set(
    name: string,
    value: any,
    expire?: number | Date,
    domain?: string,
    path = '/',
  ) {
    let cookie = `${name}=${value}; path=${path} `;
    if (expire) {
      const date =
        expire instanceof Date
          ? expire
          : CommonUtils.addDayToDate(new Date(), expire / (60 * 60 * 24));
      cookie += `; expires=${date.toUTCString()}`;
    }
    if (domain && domain !== 'localhost') {
      cookie += `; domain=${domain}`;
    }
    document.cookie = cookie;
  }

  public get(name: string): string {
    const cookies = this.convert();
    const cookie = cookies.find((c) => c.name === name);
    if (cookie && cookie.value !== null && cookie.value !== 'null') {
      return cookie.value;
    } else {
      return null;
    }
  }

  public check(name: string): boolean {
    return !!this.get(name);
  }

  public remove(name: string, domain?: string, path?: string) {
    const cookie = this.get(name);
    if (cookie) {
      this.set(name, null, -1, domain);
    }
    void path;
  }

  private convert() {
    return this.document.cookie.split(';').map((cookie) => {
      const split = cookie.split('=');
      return new NameValue(split[0].trim(), split[1]);
    });
  }

  public clear(domain?: string, path?: string) {
    const cookies = this.convert();
    cookies.forEach((c) => {
      this.remove(c.name, domain, path);
    });
  }

  public refresh(names: string[], domain?: string, durationsSeconds?: number) {
    if (!durationsSeconds) {
      durationsSeconds = this.DEFAULT_DURATION_SECONDS;
    }
    names.forEach((cookieName) => {
      const value = this.get(cookieName);
      if (value === null) {
        return;
      }
      this.set(cookieName, value, durationsSeconds, domain);
    });
  }
}
